import styled from 'styled-components'

export const StyledSpinner = styled.div<{ color?: string }>`
  width: 20px;
  height: 20px;
  border: 3px solid ${p => p.color || p.theme.colors.button.text};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
`
